import { imageDimensions } from "../customization/lib";

export class ImageValidation {
  constructor(validations) {
    this.error = "";
    this.validations = validations
    this.genericErrorMessage = `File upload failed. Files must meet specific dimension, size, and type requirements.&nbsp;
    <a href="https://support.lawlytics.com/s/article/How-to-Add-Images-or-Videos-to-a-Page" class="learn-more" target="_blank">Learn More</a>
    `
  }

  async perform({url, file}) {
    /*
        url: Url of image to validate, required if File object isn't available.
        file: File object of the image
     */
    this.url = url;
    this.file = file;

    if (this.file) {
      this.#verifySize();
    } else {
      this.#verifyExtension();
    }

    if (this.error) return this.error;

    await this.#verifyDimensions();
    if (this.error) return this.error;

  }

  reset() {
    this.error = null;
  }

  async #verifyDimensions() {
    const {height: heightMax, width: widthMax} = this.validations.maxDimensions;
    const aspectRatio = this.validations.aspectRatioLimit;
    try {
      const {width, height} = await imageDimensions(this.url);
      if (width > widthMax || height > heightMax) {
        this.error = this.genericErrorMessage;
      }

      if (height * aspectRatio < width || width * aspectRatio < height) {
        this.error = this.genericErrorMessage;
      }
    } catch (e) {
      this.error = 'The uploaded file appears to be corrupted. Please try uploading a different file.';
    }
  }

  #verifySize() {
    if (!this.file.size) {
      this.error = 'The selected file is empty. Please choose a valid file.'
      return;
    }
    if (this.file.size > this.validations.maxSize * 1000000) {
      this.error = this.genericErrorMessage;
    }
  }

  #verifyExtension() {
    const errorMessage = 'Image URL is invalid.';
    this.extension = this.url.split('.').pop().toLowerCase();
    if (!this.extension) {
      this.error = errorMessage;
      return;
    }

    if (!this.validations.formats.includes(this.extension)) {
      this.error = this.genericErrorMessage;
    }
  }
}
